import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import './Home.css';
import logo from './logo.png';
import banner1 from './assets/banners/banner1.png';
import banner2 from './assets/banners/banner2.png';
import banner3 from './assets/banners/banner3.png';
import banner4 from './assets/banners/banner4.png';
import banner5 from './assets/banners/banner5.png';
import downloadImage from './assets/download.png';

// Icon components (duplicated for standalone EN page)
const CleaningIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Cleaning">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3h18v18H3z" fill={color} opacity=".15" />
      <path d="M3 3h18v18H3z" />
      <path d="M9 9h6v6H9z" />
      <path d="M15 3v18" />
      <path d="M9 3v18" />
    </g>
  </svg>
);

const LeafIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Leaf">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3c5.5 2.5 5.5 16.5 0 19" fill={color} opacity=".15" />
      <path d="M6 3c5.5 2.5 5.5 16.5 0 19" />
      <path d="M6 3c-2.5 5.5-2.5 10.5 0 19" />
    </g>
  </svg>
);

const MedkitIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Medkit">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill={color} opacity=".15" />
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14,2 14,8 20,8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10,9 9,9 8,9" />
    </g>
  </svg>
);

const AgricultureIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Agriculture">
    <path
      d="M12 2c-4 0-8 4-8 8 0 5 8 12 8 12s8-7 8-12c0-4-4-8-8-8zm0 2c3.3 0 6 2.7 6 6 0 3.6-3.8 8.2-6 10.5C9.8 18.2 6 13.6 6 10c0-3.3 2.7-6 6-6z"
      fill={color}
      opacity=".25"
    />
    <path d="M12 4c-2.8 0-5 2.2-5 5 3 0 8-2 8-2s-2 5-2 8c2.8 0 5-2.2 5-5 0-2.8-2.2-5-5-5z" fill="none" stroke={color} strokeWidth="1.8" />
  </svg>
);

const MedicalIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Medical">
    <rect x="4" y="10" width="16" height="4" rx="1" fill={color} opacity=".2" />
    <path d="M12 5v14M5 12h14" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SpeedIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Speed">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 12l4-2" />
      <path d="M7 12h1M9 8l.7.7M15 8l-.7.7M17 12h1" />
    </g>
  </svg>
);

const QualityIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Quality">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l2.6 5.2L20 9l-4 4 .9 5.8L12 16l-4.9 2.8L8 13 4 9l5.4-.8L12 3z" fill={color} opacity=".15" />
      <path d="M12 3l2.6 5.2L20 9l-4 4 .9 5.8L12 16l-4.9 2.8L8 13 4 9l5.4-.8L12 3z" />
      <path d="M9 12l2 2 4-4" />
    </g>
  </svg>
);

const PriceTagIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Transparent pricing">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12l9-9 9 9-9 9-9-9z" fill={color} opacity=".12" />
      <path d="M3 12l9-9 9 9-9 9-9-9z" />
      <circle cx="12" cy="8.5" r="1.4" />
    </g>
  </svg>
);

const HomeEN: React.FC = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [role, setRole] = useState<'provider' | 'customer' | 'guest'>('guest');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [navOpen, setNavOpen] = useState(false);

  const slides = useMemo(
    () => [
      { id: 0, bg: `url(${banner1}) center/cover no-repeat` },
      { id: 1, bg: `url(${banner2}) center/cover no-repeat` },
      { id: 2, bg: `url(${banner3}) center/cover no-repeat` },
      { id: 3, bg: `url(${banner4}) center/cover no-repeat` },
      { id: 4, bg: `url(${banner5}) center/cover no-repeat` },
    ],
    []
  );

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          const data = userDoc.data();
          const r = (data?.role as 'provider' | 'customer') || 'customer';
          setRole(r);
        } catch (e) {
          setRole('customer');
        }
      } else {
        setRole('guest');
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(id);
  }, [slides.length]);

  useEffect(() => {
    document.title = 'Home - Fconnect';
  }, []);

  return (
    <div className="home-page">
      {/* Header */}
      <header className="home-header">
        <div className="home-container header-inner">
          <div className="brand" onClick={() => { navigate('/en'); setNavOpen(false); } }>
            <img src={logo} alt="Fconnect" />
          </div>
          <button
            className="nav-toggle"
            aria-label={navOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={navOpen}
            aria-controls="main-navigation"
            onClick={() => setNavOpen((o) => !o)}
          >
            {navOpen ? '✕' : '☰'}
          </button>
          <nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
            <Link to="/en" onClick={() => setNavOpen(false)}>Home</Link>
            <Link to="/en/general-labor" onClick={() => setNavOpen(false)}>General labor</Link>
            <Link to="/en/agricultural-labor" onClick={() => setNavOpen(false)}>Agricultural labor</Link>
            <Link to="/en/healthcare-services" onClick={() => setNavOpen(false)}>Healthcare services</Link>
            <Link to="/en/privacy" onClick={() => setNavOpen(false)}>Privacy Policy</Link>
            <Link to="/en/terms" onClick={() => setNavOpen(false)}>Terms</Link>
            <Link to="/en/contact" onClick={() => setNavOpen(false)}>Contact</Link>
            <Link to="/" className="lang-link" onClick={() => setNavOpen(false)}>Tiếng Việt</Link>
          </nav>
        </div>
      </header>
      <div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

      {/* Banner / Carousel */}
      <section className="banner-section">
        <div className="carousel">
          {slides.map((slide, idx) => (
            <div
              key={slide.id}
              className={`slide ${idx === currentSlide ? 'active' : ''}`}
              style={{ background: slide.bg }}
            >
            </div>
          ))}
          <div className="carousel-controls">
            <button
              className="carousel-control prev"
              aria-label="Previous slide"
              onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
            >
              ‹
            </button>
            <button
              className="carousel-control next"
              aria-label="Next slide"
              onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
            >
              ›
            </button>
          </div>
        </div>
      </section>

      {/* About Fconnect */}
      <section className="about-section">
        <div className="home-container">
          <div className="about-inner">
            <div className="about-copy">
              <h3 className="about-title">About Fconnect</h3>
              <p className="about-subtitle">Fconnect connects users with trusted home service providers, helping you book and manage everything in just a few steps.</p>
              <ul className="about-list">
                <li>Diverse categories: general labor, agriculture, healthcare...</li>
                <li>Quick booking, real-time status tracking</li>
                <li>Transparent reviews and pricing</li>
              </ul>
              <div className="about-actions">
                <a
                  className="promo-cta"
                  href="#download"
                  aria-label="Download app"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('download')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }}
                >
                  Download app
                </a>
              </div>
            </div>
            <div className="about-visual" aria-hidden="true">
              <div className="about-card">
                <div className="about-badge">Fconnect</div>
                <div className="about-card-title">Connecting home services</div>
                <div className="about-card-sub">Fast • Reliable • Transparent</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="services-section" id="services">
        <div className="home-container">
          <h3 className="section-title">Main services</h3>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon"><CleaningIcon size={56} /></div>
              <h4>General labor</h4>
              <p>Domestic help, cleaning, assisting tasks, light installations.</p>
              <Link to="/en/general-labor" className="service-cta">View details</Link>
            </div>
            <div className="service-card">
              <div className="service-icon"><LeafIcon size={56} /></div>
              <h4>Agricultural labor</h4>
              <p>Garden and crop care with modern techniques.</p>
              <Link to="/en/agricultural-labor" className="service-cta">View details</Link>
            </div>
            <div className="service-card">
              <div className="service-icon"><MedkitIcon size={56} /></div>
              <h4>Healthcare services</h4>
              <p>Testing, consultation and prescription fulfillment by professionals.</p>
              <Link to="/en/healthcare-services" className="service-cta">View details</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="benefits-section">
        <div className="home-container">
          <h3 className="section-title">Benefits of Fconnect</h3>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon" aria-hidden="true"><SpeedIcon size={56} /></div>
              <h4 className="benefit-title">Fast & convenient</h4>
              <p>Book in a few steps. Track in real-time to save your time.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon" aria-hidden="true"><QualityIcon size={56} /></div>
              <h4 className="benefit-title">Quality guaranteed</h4>
              <p>Verified providers and transparent reviews. Service standards are monitored.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon" aria-hidden="true"><PriceTagIcon size={56} /></div>
              <h4 className="benefit-title">Transparent pricing</h4>
              <p>Clear prices with no hidden fees. Compare and choose the right plan.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Promo Info */}
      <section className="promo-section">
        <div className="home-container">
          <div className="promo-inner">
            <div className="promo-visual" aria-hidden="true">
              <div className="coupon-card">
                <div className="coupon-chip"></div>
                <div className="coupon-content">
                  <div className="coupon-heading">Attractive promotions</div>
                  <div className="coupon-value">Various offers</div>
                  <div className="coupon-note">Download the app to receive frequent offers</div>
                </div>
                <div className="coupon-code">Download app to get offers</div>
              </div>
            </div>
            <div className="promo-copy">
              <h3 className="promo-title">Promotion information</h3>
              <p className="promo-subtitle">Plenty of attractive promotions when you download and use Fconnect: discounts, gifts, exclusive deals and more.</p>
              <ul className="promo-list">
                <li>Welcome offers for new users</li>
                <li>Seasonal promotions and special events</li>
                <li>Gifts and reward points for members</li>
              </ul>
              <div className="promo-actions">
                <a
                  className="promo-cta"
                  href="#download"
                  aria-label="Download app"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('download')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }}
                >
                  Download app
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Download App */}
      <section className="download-section" id="download">
        <div className="home-container">
          <div className="download-inner">
            <div className="download-copy">
              <h3 className="download-title">Enjoy the full experience with Fconnect app</h3>
              <p className="download-subtitle">Download the app to book faster, track and manage anytime, anywhere.</p>
              <div className="store-badges">
                <a
                  className="store-badge appstore-badge"
                  href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="badge-icon" aria-hidden="true"></span>
                  <span className="badge-text">
                    <span className="badge-sub">Download on the</span>
                    <span className="badge-brand">App Store</span>
                  </span>
                </a>
                <a
                  className="store-badge play-badge"
                  href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="badge-icon" aria-hidden="true">▶</span>
                  <span className="badge-text">
                    <span className="badge-sub">GET IT ON</span>
                    <span className="badge-brand">Google Play</span>
                  </span>
                </a>
              </div>
            </div>
            <div className="download-visual" aria-hidden="true">
              <img src={downloadImage} alt="Fconnect application" className="download-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-container footer-inner">
          <div className="footer-contact">
            <p><strong>HIEP TIN PHAT FINANCE JOINT STOCK COMPANY</strong></p>
            <p><strong>Email:</strong> trile@fconnect.vn</p>
            <p><strong>Phone:</strong> 02513684266</p>
            <p><strong>Address:</strong> 11/4C, To 15, Kp 6, Nguyen Ai Quoc Street, Tran Bien Ward, Dong Nai City, Vietnam</p>
            <p><strong>Support hours:</strong> 8:00 - 22:00 (Mon - Sun)</p>
          </div>
          <div className="footer-stores">
            <a
              className="store-badge small appstore-badge"
              href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="badge-icon" aria-hidden="true"></span>
              <span className="badge-text">
                <span className="badge-sub">Download on the</span>
                <span className="badge-brand">App Store</span>
              </span>
            </a>
            <a
              className="store-badge small play-badge"
              href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="badge-icon" aria-hidden="true">▶</span>
              <span className="badge-text">
                <span className="badge-sub">GET IT ON</span>
                <span className="badge-brand">Google Play</span>
              </span>
            </a>
          </div>
        </div>
        <div className="copyright">© 2025 Fconnect. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default HomeEN;


